export enum GroupSearchStatus {
  Private = 0,
  Public = 1,
}

export enum GroupStatus {
  Normal = 1,
  DISBAND = 2,
}

export enum GroupType {
  COMMON = 0,
  TEMP,
}

export enum GroupEncryptionStatus {
  NO = 0,
  IS,
}

export interface CreateGroupParams {
  group_name?: string;
  group_head?: string;
  description?: string;
  search_key_word?: string;
  search_status?: GroupSearchStatus;
  invite_member_list?: string[];
  group_type?: GroupType;
  related_gid?: string;
  is_encryption: GroupEncryptionStatus;
}

export interface GroupInfo {
  gid: string;
  group_name: string;
  group_head: string;
  description: string;
  status: GroupStatus;
  search_status: GroupSearchStatus;
  create_at: number;
  creator_uid: string;
  join_type?: number;
  is_encryption: GroupEncryptionStatus;
}

export enum GroupPosition {
  Owner = 1,
  Manager = 2,
  Member = 3,
}

export interface GroupMemberList {
  id: string;
  gid: string;
  member_uid: string;
  user_name: string;
  group_position: GroupPosition;
  group_nickname: string;
  avatar: string;
  created_at: number;
  updated_at: number;
}

export interface UpdateGroupInfoParams {
  gid: string;
  group_name?: string;
  group_head?: string;
  description?: string;
  search_key_word?: string;
  search_status?: GroupSearchStatus;
  join_type?: number;
}

export interface GroupSettings {
  gid: string;
  edit_group_name: number;
  edit_group_description: number;
  pin_to_all: number;
  at_all: number;
  speak: number;
  speak_person: string[];
  hide_member_number: number;
  group_public: number;
  group_verify: number;
  anon_mode: number;
  tag_manage: number;
  bot_manage: number;
  member_enter_notice: number;
  member_exit_notice: number;
  group_welcome: string;
  group_auto_reply: string;
  display_keywords: string[];
  speak_limit: {
    enable: number;
    time: number;
    count: number;
  };
  expire_duration: number;
}

export interface UpdateUserkeyPackageParams {
  uid: string;
  key: string;
  hash_ref: string;
}

export interface GroupEncryptInfoParams {
  gid: string;
  data: string;
  epoch: number;
}

export interface RefreshGroupEncryptInfoParams extends GroupEncryptInfoParams {
  commit: string;
}

export interface GroupEncryptMembersParams {
  gid: string;
  uids: string[];
  data: string;
  epoch: number;
  welcome?: string;
  commit: string;
}

export interface GroupEncryptCommitsParams {
  gid: string;
  commit: string;
  epoch: number;
}
